import React from 'react';
export { privacyHandle as handle } from '../routeMetadata';
import { Link } from 'react-router';
import { TAN_BG } from '../data/constants';

interface PrivacyPolicySectionProps {
  title: string;
  children: React.ReactNode;
}

function PrivacyPolicySection({ title, children }: PrivacyPolicySectionProps) {
  return (
    <div className="flex flex-col gap-4 mb-8 round-md bg-white p-4 shadow-md max-w-[800px] mx-auto">
      <h2 className="text-xl font-semibold mb-1">{title}</h2>
      {children}
    </div>
  );
}

export default function PrivacyPolicy() {
  return (
    <div
      className="px-4 py-8"
      style={{ backgroundColor: TAN_BG }}
    >
      <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
      <div className="max-w-none">
        <div className="flex flex-col gap-4 mb-8 round-md bg-white p-4 shadow-md max-w-[800px] mx-auto">
          <h2 className="text-xl font-semibold mb-1">Relationship to Terms of Service</h2>
          <p>
            Our Privacy Policy is dependent on and must be considered in the context of our
            {' '}
            <Link to="/terms">Terms of Service</Link>
            . The Terms of Service outlines all the terms surrounding enforcement of privacy, and any use of our services or interpretation of our privacy practices is subject to the terms, limitations, and definitions set forth in that document. Please review both documents together for a complete understanding of your rights and obligations.
          </p>
        </div>
        <PrivacyPolicySection title="What Personal Information About Customers Do We Collect?">
          <p>
            We collect your personal information to successfully complete the services you trust us to do, and continually improve on our ability to do so. This information includes the information you enter while you're using the site, analytics about your usage of the site, details from our communications (like if you call us or we call you), our email exchanges, and our interpersonal exchanges (like when we deliver to you).
          </p>
        </PrivacyPolicySection>
        <PrivacyPolicySection title="What Do We Use Your Personal Information to Do?">
          <p>
            We use your personal information to inform the processes that make what we do possible, namely to operate and provide, and continually better provide, a colorful gamut of time-saving and access-expanding services available at your door. This includes information to make the website easier to use, improved product and service selection, and possibly communications about promotions.
          </p>
        </PrivacyPolicySection>
        <PrivacyPolicySection title="Do We Set Cookies?">
          <p>
            We use Cookies and other browser storage to identify and support your usage of our website and our services. This makes our analytics more useful, which lets us know how we can be doing things better, and it also improves our monitoring, which lets us diagnose and solve problems faster.
          </p>
          <p>
            Additionally, we use a number of services to support the behavior of our web experience, which each leverage Cookies and other forms of browser storage to support their behavior and tracking. We understand all these Cookies to be vital for core operation, security, and expected website behavior, so they cannot be disabled.
          </p>
        </PrivacyPolicySection>
        <PrivacyPolicySection title="Do We Share Your Data?">
          <p>
            We do use a number of services to support our operations, such as Stripe for Payment Processing and Google for mapping services. These and several other services like these use different parts of your data to support features vital to the core operation of BLC.
          </p>
          <p>
            But no, we don't sell your data, we won't sell your data, and we quiver at the thought of it. What data we collect we strictly use in our direct capacity to further our mission of getting more New Yorkers to use bidets.
          </p>
        </PrivacyPolicySection>
        <PrivacyPolicySection title="How secure is my information?">
          <p>
            We take every reasonable precaution to keep your data safe. Given the size of our company, the NSA could hack us and we likely wouldn't know (most companies would never tell you that, but we're better 👍), but for regular people, our site is secure.
          </p>
          <p>
            We encrypt all web traffic; we delegate the handling of all your trusted financial data to an extremely reputable payment processor, Stripe, and don't store or transmit it directly ourselves; we follow an informed and closely enforced procedure of code, data, and configuration practices that limit data exposure past necessity; we follow modern security data storage practices via well-supported infrastructure hosted by reputable providers.
          </p>
        </PrivacyPolicySection>
        <PrivacyPolicySection title="What Is the Minimum Age to Use Our Services?">
          <p>
            Generally, we offer our services to the legal operators of a property. If you are under 18, you must have the permission of a parent or guardian to use our services or some other equivalent proof of status as an operator. We do not knowingly collect personal information from children under 13. If we learn that we have collected personal information from a child under 13, we will delete that information as quickly as possible.
          </p>
        </PrivacyPolicySection>
        <PrivacyPolicySection title="Terms of Service and Revisions">
          <p>
            When using our website, our services, and interacting with us, your use and disputes regarding privacy are subject to this Privacy Policy and our
            {' '}
            <Link to="/terms">Terms of Service</Link>
            , including the application of the law in the state of New York and limitations on damages and losses.
          </p>
        </PrivacyPolicySection>
      </div>
    </div>
  );
}
